import { useStore } from 'effector-react'
import { UseFormReturn } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { inspectionFormModel } from '~/entities/Inspection'
import { Button } from '~/shared/ui/Buttons'
import { Checkbox, FormProvider } from '~/shared/ui/form'
import { Skeleton } from '~/shared/ui/SkeletonList'
import { FormHeader } from '../FormHeader'
import { CheckBoxListWrapper, Wrapper } from './styled'
import { CarBodyInspectionFormValues } from './types'
import { Wheels } from './Wheels'

type CarBodyInspectionFormProps = {
  onSuccess: () => void
  form: UseFormReturn<CarBodyInspectionFormValues>
}

export function CarBodyInspectionForm({
  onSuccess,
  form,
}: CarBodyInspectionFormProps) {
  const { t } = useTranslation()

  const carEquipmentsExteriorOptions = useStore(
    inspectionFormModel.$carEquipmentsExteriorOptions,
  )
  const isCarEquipmentsPending = useStore(
    inspectionFormModel.requestCarEquipmentsFx.pending,
  )

  return (
    <FormProvider form={form} onSuccess={onSuccess}>
      <Wrapper>
        <FormHeader title='form.completeness' />

        {isCarEquipmentsPending && <Skeleton animated $height={150} />}

        <CheckBoxListWrapper>
          {!isCarEquipmentsPending &&
            carEquipmentsExteriorOptions.map((param) => (
              <Checkbox
                key={param.id}
                label={param.label}
                name={`equipmentsExterior.${param.id}`}
              />
            ))}
        </CheckBoxListWrapper>

        <FormHeader title='form.type of tires and rims' />

        <Wheels form={form} />

        <Button
          fullWidth
          type='submit'
          variant='limeFlooded'
          uppercase
          style={{ marginTop: '16px' }}
        >
          {t('button.inspect interior')}
        </Button>
      </Wrapper>
    </FormProvider>
  )
}
